import { render, staticRenderFns } from "./AdvAllTpyeStatic.vue?vue&type=template&id=2f8f92e8&scoped=true&"
import script from "./AdvAllTpyeStatic.vue?vue&type=script&lang=js&"
export * from "./AdvAllTpyeStatic.vue?vue&type=script&lang=js&"
import style0 from "./AdvAllTpyeStatic.vue?vue&type=style&index=0&id=2f8f92e8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f92e8",
  null
  
)

export default component.exports